var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('compute.text_113'),"tabs":_vm.tabOptions,"current-tab":_vm.curTab},on:{"update:currentTab":function($event){_vm.curTab=$event},"update:current-tab":function($event){_vm.curTab=$event}}}),_c('page-body',[_c(_vm.curTab,{tag:"component",attrs:{"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }